function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconButton, Menu, MenuButton, MenuDivider, MenuItem, MenuList, useClipboard } from '@chakra-ui/react';
import { faCheckCircle, faCopy, faEllipsisV, faRefresh } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
function getEntryUserName(param) {
    var name = param.name, displayName = param.displayName;
    if (name.toLowerCase() === displayName.toLowerCase()) {
        return displayName;
    }
    return "".concat(displayName, " (").concat(name, ")");
}
export default function GiveawayMenu(param) {
    var onReset = param.onReset, users = param.users, entries = param.entries;
    var _React_useState = _sliced_to_array(React.useState(false), 2), open = _React_useState[0], setOpen = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(''), 2), copyEntriesText = _React_useState1[0], setCopyEntriesText = _React_useState1[1];
    useEffect(function() {
        if (!open) {
            setCopyEntriesText(null);
            return;
        }
        // for better performance, we delay the copy text generation to the next tick
        var timeout = setTimeout(function() {
            setCopyEntriesText(entries.map(function(entry) {
                return users.get(entry);
            }).filter(function(user) {
                return (user === null || user === void 0 ? void 0 : user.eligible) === true;
            })// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            .map(function(user) {
                return getEntryUserName(user);
            }).join('\n'));
        }, 0);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        open,
        entries,
        users
    ]);
    var _useClipboard = useClipboard(copyEntriesText !== null && copyEntriesText !== void 0 ? copyEntriesText : ''), onCopy = _useClipboard.onCopy, hasCopied = _useClipboard.hasCopied;
    return /*#__PURE__*/ _jsxs(Menu, {
        placement: "bottom-end",
        closeOnSelect: false,
        onOpen: function() {
            return setOpen(true);
        },
        onClose: function() {
            return setOpen(false);
        },
        children: [
            /*#__PURE__*/ _jsx(MenuButton, {
                as: IconButton,
                icon: /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: faEllipsisV
                })
            }),
            /*#__PURE__*/ _jsxs(MenuList, {
                children: [
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: hasCopied ? faCheckCircle : faCopy
                        }),
                        onClick: onCopy,
                        color: hasCopied ? 'success' : undefined,
                        isDisabled: copyEntriesText == null,
                        children: hasCopied ? /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "2BfifT",
                            defaultMessage: "Copied all"
                        }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "WeNI+7",
                            defaultMessage: "Copy Eligible Entries"
                        })
                    }),
                    /*#__PURE__*/ _jsx(MenuDivider, {}),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faRefresh
                        }),
                        onClick: onReset,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "l+MC4Y",
                            defaultMessage: "Reset all Entries"
                        })
                    })
                ]
            })
        ]
    });
}
